import React, { useState } from "react";
import { withRouter, Prompt } from 'react-router-dom'
import Modal from "../Modal/Modal";
import CancelButton from "../Buttons/CancelButton";
import ConfirmButton from "../Buttons/ConfirmButton";

function UnsavedChangesPopup(props) {
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const [pathname, setPathname] = useState("");
    const { is_dirty } = props;

    return <>
        <Prompt
            message={(location, action) => {
                if (!is_dirty || (location.state && location.state.confirmNav)) {
                    return true;
                }
                else {
                    setShowConfirmPopup(true);
                    setPathname(location.pathname)
                    return false;
                }
            }}
        />
        <Modal
            show={showConfirmPopup}
            onClose={() => setShowConfirmPopup(false)}
            header="You Have Unsaved Changes"
            className="delete-modal"
        >
            <div className="center-text">Leave without saving changes?</div>
            <div className="row mt-3">
                <div className="col-lg-6">
                    <CancelButton
                        className="mt-3"
                        onClick={() => setShowConfirmPopup(false)}
                    >No</CancelButton>
                </div>
                <div className="col-lg-6">
                    <ConfirmButton
                        className="mt-3"
                        onClick={() => {
                            setShowConfirmPopup(false)
                            props.history.push(pathname, { confirmNav: true })
                        }}>Yes</ConfirmButton>
                </div>
            </div>
        </Modal>
    </>
}

export default withRouter(UnsavedChangesPopup);